import ReservationMixin from '../../../mixin/tickets'
import DatesMixin from '../../../../../components/_mixins/dates'

export default {
  name: 'mini-cart',
  mixins: [ReservationMixin, DatesMixin],
  data() {
    return {
    }
  },
  computed: {
    miniCartItems() {
      return this.proposedCartItems
    },
    subTotal() {
      return _.reduce(this.miniCartItems, (total, item) => {
        return total + this.getItemSubTotal(item)
      }, 0)
    },
    taxTotal() {
      return _.reduce(this.miniCartItems, (total, item) => {
        return total + this.getItemTaxTotal(item)
      }, 0)
    },
    netTotal() {
      return this.subTotal + this.taxTotal
    },
  },
  methods:{
    getItemTitle(item) {
      return item.title
    },
    getItemSlot(item) {
      return item.slot
    },
    getItemDate(item) {
      return item.formattedDate
    },
    getItemTime(item) {
      return item.formattedTime
    },
    getItemDateTime(item) {
      return _.filter([this.getItemDate(item), this.getItemTime(item)]).join(', ')
    },
    getItemPricing(item) {
      return item.pricing || {}
    },
    getItemQuantity(item){
      return this.getItemPricing(item).count
    },
    getItemRate(item) {
      return this.getItemPricing(item).rate
    },
    getItemSubTotal(item) {
      return this.getItemPricing(item).subtotal
    },
    getItemTaxTotal(item) {
      return this.getItemPricing(item).tax
    },
    getItemTotal(item) {
      return this.getItemPricing(item).total
    },
  }
}
